// Route Code Edited 06/09/2026
/**
 * Route Widget Label Override — Fear of God
 *
 * Purpose:
 *   Removes the " package protection" suffix from the Route shipping
 *   protection checkout button label (PC EQ widget) in the cart drawer, 
 *   leaving only the quoted price (e.g. "+$31.63" instead of 
 *   "+$31.63 package protection").
 *
 * How it works:
 *   A MutationObserver is attached to #CartDrawer, which is the innermost
 *   DOM element that survives Shopify cart AJAX updates on this store.
 *   On every mutation, trimRoutePremiumLabel() queries for all instances of
 *   span.route-premium-text-stacked and replaces their text content with
 *   only the first whitespace-delimited token (the price). The transform
 *   is also applied once on observer attachment to catch any widget already
 *   present in the DOM at load time.
 *
 * Failure behavior:
 *   If the Route widget markup changes in a future update and the regex
 *   does not match, the original text is left untouched. All mutations are
 *   wrapped in a try/catch so any unexpected DOM state cannot throw an
 *   error that would affect the rest of the page.
 *
 * Revert:
 *   Remove the <script> tag referencing this file from layout/theme.liquid (lines 925-927).
 *   This will immediately disable the script and the Route widget will revert to its default
 *   unmodified output. 
 *   Optionally, you can also remove this file, as it will no longer be used after the call in
 *   the theme.liquid file is removed.
 *
 * Scope:
 *   Drawer cart only (#CartDrawer). No cart page or other cart contexts
 *   are present on the store at this time.
 */
(function() {

  function trimRoutePremiumLabel(root) {
    try {
      var targets = root.querySelectorAll('span.route-premium-text-stacked'); // 'span.route-premium-text-stacked:not([data-route-modified])'
      targets.forEach(function(span) {
        var text = span.textContent;
        var match = text.match(/[^\s]+(?=\s|$)/);
        if (match && match[0] !== text.trim()) {
          span.textContent = match[0];
          // span.setAttribute("data-route-modified", "");
        }
      });
    } catch (e) {
      // silent — original text remains untouched
    }
  }

  function attachRouteObserver(ancestorSelector) {
    var ancestor = document.querySelector(ancestorSelector);
    if (!ancestor) return;

    trimRoutePremiumLabel(ancestor);

    var observer = new MutationObserver(function() {
      trimRoutePremiumLabel(ancestor);
    });

    observer.observe(ancestor, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function() {
    attachRouteObserver('.cart-drawer__dialog');
  });

})();
// End Route Code